/*global translate*/

import React, { Component, useState } from 'react'
import { connect } from 'react-redux'
import { VariableSizeList } from 'react-window';
const { rxaget, stringToColour, rxChangeSlug, subString, changeColorSVG } = global.rootRequire('classes/ulti')
const { checkNameContact, checkNameUser, changeColorAva, textAva } = global.rootRequire('classes/chat')
const { rxgetLocal } = global.rootRequire('classes/request')
const { chooseGroupAction, closeCreateGroupPopup, changeStatusLoadMess, netaGroupsUpdate, updateGroupsDraft, changeGroupFunc } = global.rootRequire('redux')
const rxio = global.rootRequire('classes/socket').default
const chatDB = global.rootRequire('classes/indexedDB').default
const workerGroup = global.rootRequire('classes/globalGroups')
const workerUnread = global.rootRequire('classes/globalUnread')

const GroupPopupItem = global.rootRequire('components/shares/create_group_popup/rxGroupPopupItem').default
const ListMemberRow = global.rootRequire('components/shares/create_group_popup/rxListMemberRow').default
// global.isclient && require('./../rxPopup.css')
function InputGroupName({ value = "", onChange }) {
  const [text, setText] = useState(value)

  function update(event) {
    setText(event.target.value);
    if (typeof onChange === 'function') {
      onChange(event.target.value)
    }
  }

  return (
    <input type="text" placeholder={translate("Enter a group name")} maxLength="30" className="newgroup_place" onChange={update} value={text} />
  )
}

let timeout = null
function SearchUserName({ value = "", onChange, theme }) {
  const [text, setText] = useState(value)

  function updateSearch(event) {
    setText(event.target.value)
    try {
      let strText = event.target.value
      if (timeout) {
        clearTimeout(timeout)
      }
      if (strText.length === 0) {
        onChange(strText)
      } else {
        timeout = setTimeout(function () {
          if (typeof onChange === 'function' && strText) {
            onChange(strText)
          }
        }, 500);
      }
    } catch (e) { }
  }

  return (
    <div className='popup_choose_leader_search_area'>
      <div className='popup_choose_leader_icon_search_area'>
        <img className='popup_choose_leader_icon_search filter_img_class' src={changeColorSVG('./images/default/icons/search-active.svg')} alt='' />
      </div>
      <input type='search' maxLength='30' id='newgroup_search_input' placeholder={translate("Search")} onChange={updateSearch} value={text} autoComplete='off'
        className={theme === 'darkTheme' ? 'popup_choose_leader_search_input darkThemeInput' : 'popup_choose_leader_search_input lightThemeInput'}>
      </input>
    </div>
  )
}

class RxGroupList extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      user: {},
      group: {},
      groupsNChat: [],
      groupsNChatOrigin: [],
      groupsNChatChecked: [],
      groupsNChatCheckedUser: [],
      flagPopup: false,
      flagCreateGroup: false,
      flagCreateGroupPopup: false,
      nameNewGroup: '',
      typePopup: '',
      groupImage: '',
      chooseFileImagesStatus: false,
      groupImageURL: '',
      heightListMember: 0,
      pagingSearch: 0,
      tabTypeGroup: '2'
    }
    this.compareContact = this.compareContact.bind(this)
    this.token = rxaget(this.props, 'netaauth.user.token', '')
    this.users = rxaget(this.props, 'user.users', {}) || {}
    this.userid = rxaget(this.props, 'netaauth.user.id', '')

    this.groupName = ''
    this.searchUserName = ''

    this.flagBtnGroup = false
    this.flagBtnChat = false
    this.blockScroll = false

    this.createNewChat = this.createNewChat.bind(this)
    this.handleScrollList = this.handleScrollList.bind(this)
  }


  UNSAFE_componentWillReceiveProps(nextProps) {
    let nextPopup = rxaget(nextProps, 'netaCreateGroupPopup', {})
    if (nextPopup.status) {
      let user = rxaget(nextPopup, 'data.user', {})
      let group = rxaget(nextPopup, 'data.group', {})
      let flagPopup = rxaget(nextPopup, 'status', false)
      let arrGroupsTmp = rxaget(nextPopup, 'data.groups', []).filter(o => o.id !== user.id)

      let flagCreateGroup = (['create_chat', 'create_channel', 'create_group'].indexOf(nextPopup.type_popup) !== -1) ? true : false
      let flagCreateGroupPopup = (['create_group', 'create_channel'].indexOf(nextPopup.type_popup) !== -1) ? true : false


      chatDB.contacts.limit(40).toArray().then(arrContact => {

        let userid = rxaget(this.props, 'netaauth.user.id', '')
        let arrUsername = arrContact.map(u => u.phone)
        chatDB.users.filter((user) => { return (arrUsername.indexOf(user.phone) !== -1) })
          .limit(40)
          .toArray()
          .then((arrUsers) => {
            if (arrUsers && arrUsers.constructor === Array) {
              let userid = rxaget(this.props, 'netaauth.user.id', '')
              let arrGroupsTmp = arrUsers.sort(this.compareContact)
              let arrContact = []

              for (let i in arrGroupsTmp) {
                let uCurrent = arrGroupsTmp[i]
                let uPrev = (i > 0) ? arrGroupsTmp[i - 1] : {}

                if (uCurrent.id.toString() !== userid.toString()) {
                  let contactTitle = ''
                  let eleContactTitle = rxChangeSlug(checkNameUser(uCurrent, this.userid, this.props.netaauth)).slice(0, 1)
                  let elePreContactTitle = rxChangeSlug(checkNameUser(uPrev, this.userid, this.props.netaauth)).slice(0, 1)

                  if (elePreContactTitle !== eleContactTitle && eleContactTitle) {
                    arrContact.push({ id: -1, contactTitle: eleContactTitle })
                  }

                  arrContact.push(uCurrent)
                }
              }

              this.setState({
                groupsNChat: arrContact,
                groupsNChatOrigin: arrContact
              })

            }
          })
      })


      this.setState({
        flagPopup: flagPopup,
        flagCreateGroup: flagCreateGroup,
        flagCreateGroupPopup: (this.state.flagCreateGroupPopup) ? this.state.flagCreateGroupPopup : flagCreateGroupPopup,
        typePopup: nextPopup.type_popup,
        user: user,
        group: group
      })
    }
  }

  onClickClosePopup() {
    this.resetState()
  }

  onClickShowPopupCreateGroup() {
    let flagCreateGroupPopup = this.state.flagCreateGroupPopup
    this.setState({ flagCreateGroupPopup: !flagCreateGroupPopup })
  }

  compareContact(a, b) {
    let userA = rxChangeSlug(checkNameUser(a, this.userid, this.props.netaauth))
    let userB = rxChangeSlug(checkNameUser(b, this.userid, this.props.netaauth))

    if (userA < userB) {
      return -1;
    }
    if (userA > userB) {
      return 1;
    }
    return 0;
  }

  onCallAPISearch(value, paging) {
    let pagingSearch = 0
    let pageLimit = 20
    if (value === this.state.searchNchatValue && paging > 0) {
      pagingSearch = paging
    } else if (value !== this.state.searchNchatValue) {
      this.setState({
        groupsNChat: [],
        groupsNChatOrigin: [],
        searchNchatValue: value,
        pagingSearch: 0,
        heightListMember: 0
      })
    }
    const api_search = global.rxu.config.get_phone
    fetch(api_search + '?type=1&username=' + encodeURIComponent(value) + '&offset=' + pagingSearch * pageLimit + '&limit=' + pageLimit, {
      method: 'GET',
      headers: { Accept: 'application/json', 'TC-Token': this.token, Connection: 'Keep-Alive', 'Accept-Encoding': 'gzip' }
    })
      .then(res => res.json())
      .then((json) => {
        try {
          if (json) {
            let result = json
            if (paging) {
              let groupsNChatOrigin = this.state.groupsNChat
              groupsNChatOrigin = groupsNChatOrigin.filter(uGrp => uGrp.id !== -1)
              result = [...groupsNChatOrigin, ...json]
            }

            let arrGroupsTmp = result
            let arrContact = []

            arrGroupsTmp = arrGroupsTmp.filter((value, index, self) =>
              index === self.findIndex((t) => (
                t.Id === value.Id
              ))
            )

            let heightListMember = 0
            for (let i in arrGroupsTmp) {
              let uCurrent = arrGroupsTmp[i]
              uCurrent.id = uCurrent.Id
              let uPrev = (i > 0) ? arrGroupsTmp[i - 1] : {}

              if (uCurrent.id.toString() !== this.userid.toString()) {
                let contactTitle = ''
                let eleContactTitle = rxChangeSlug(checkNameUser(uCurrent, this.userid, this.props.netaauth)).slice(0, 1)
                let elePreContactTitle = rxChangeSlug(checkNameUser(uPrev, this.userid, this.props.netaauth)).slice(0, 1)

                heightListMember += 60
                arrContact.push(uCurrent)
              }
            }

            this.setState({
              groupsNChat: arrContact,
              groupsNChatOrigin: arrContact,
              searchNchatValue: value,
              pagingSearch: pagingSearch,
              heightListMember: heightListMember
            }, () => {
              setTimeout(() => {
                this.blockScroll = false
              }, 500)
            })

          } else {
            this.blockScroll = false
          }
        } catch (e) {
          console.log(e)
          this.blockScroll = false
        }
      })
      .catch(er => { console.log('can\'t search users'); this.blockScroll = false; return er })
  }

  onChangeSearchNChat(value, paging) {
    let arrGroups
    let statusSeachNchatValue

    if (this.state.typePopup === 'create_chat' || value === '') {
      chatDB.users.filter((user) => { return (rxChangeSlug(rxaget(user, 'full_name', '')).indexOf(rxChangeSlug(value)) !== -1 || ((user && user.phone && rxChangeSlug(user.phone).toString().indexOf(rxChangeSlug(value)) !== -1))) })
        .limit(40)
        .toArray()
        .then((result) => {
          let arrGroupsTmp = result.sort(this.compareContact)
          let arrContact = []

          for (let i in arrGroupsTmp) {
            let uCurrent = arrGroupsTmp[i]
            let uPrev = (i > 0) ? arrGroupsTmp[i - 1] : {}

            if (uCurrent.id.toString() !== this.userid.toString()) {
              let contactTitle = ''
              let eleContactTitle = rxChangeSlug(checkNameUser(uCurrent, this.userid, this.props.netaauth)).slice(0, 1)
              let elePreContactTitle = rxChangeSlug(checkNameUser(uPrev, this.userid, this.props.netaauth)).slice(0, 1)

              if (elePreContactTitle !== eleContactTitle && eleContactTitle) {
                arrContact.push({ id: -1, contactTitle: eleContactTitle })
              }

              arrContact.push(uCurrent)
            }
          }

          if (!value) {
            arrContact = this.state.groupsNChatOrigin
          }

          this.setState({
            groupsNChat: arrContact,
            // groupsNChatOrigin: arrContact,
            statusSeachNchatValue: statusSeachNchatValue,
            searchNchatValue: value,
            pagingSearch: 0
          })
        })
    } else {
      this.onCallAPISearch(value)
    }
  }

  createNewChat(user) {
    let flagCreateGroupPopup = this.state.flagCreateGroupPopup
    let typePopup = this.state.typePopup
    if (flagCreateGroupPopup) {

      let groupsNChatChecked = this.state.groupsNChatChecked
      let groupsNChatCheckedUser = this.state.groupsNChatCheckedUser
      if (groupsNChatChecked.indexOf(user.id) === -1) {
        groupsNChatChecked.push(user.id)
        groupsNChatCheckedUser.push(user)
      } else {
        groupsNChatChecked.splice(groupsNChatChecked.indexOf(user.id), 1)

        const findIndex = groupsNChatCheckedUser.findIndex(u => u.id === user.id)
        if (findIndex !== -1) {
          groupsNChatCheckedUser.splice(findIndex, 1)
        }
      }
      this.flagBtnGroup = false
      this.setState({ groupsNChatChecked, groupsNChatCheckedUser })
    } else {
      if (typePopup === 'create_chat') {
        let userOwner = rxaget(this.state, 'user', {})
        let partner_id = user.id.toString()
        const params = {
          'type': 3,
          'owner_uin': userOwner.id,
          'name': '',
          'avatar_url': '',
          'occupants_uins': [userOwner.id, partner_id],
          'sender_name': userOwner.name
        }
        try {
          if (this.props.netaCreateGroupPopup && this.props.netaCreateGroupPopup.status) {
            let funcCreateGroup = this.props.netaCreateGroupPopup.callback
            console.log(funcCreateGroup, "???")
            let userid = userOwner.id.toString()

            let params = {
              'type': 3,
              'occupants_uins': [partner_id, userid]
            }

            let createdAt = new Date().getTime() * 1000

            if (!this.flagBtnChat) {
              this.flagBtnChat = true
              rxio.checkGroup(params, (data) => {
                let last_message = {
                  'attachments': "",
                  'created_at': createdAt
                }

                if (data && data.group) {
                  let group = data.group
                  let group_id = data.group.group_id

                  let netaGroups = global.rxu.json(rxgetLocal('netaGroups'), { status: false, init: false, groups: {}, group_id_change: '' })

                  if (!netaGroups.groups[group_id]) {
                    group.last_message = last_message
                    group.isDraft = true

                    let newnameuser = checkNameUser(user) || ''
                    group['fullnamegroup'] = (user.full_name) ? user.full_name : (newnameuser) ? newnameuser : user.phone || ''
                    group.group_fullname = group['fullnamegroup']

                    this.props.netaGroupsUpdate(group.group_id, group)
                    this.props.chooseGroupAction(group)
                  } else {
                    this.props.chooseGroupAction(group)
                  }
                } else {
                  let objGroup = JSON.parse(JSON.stringify({
                    'admin_uins': [userid],
                    'avatar_url': user.profile_url || '',
                    'background': "",
                    'blocked_uins': [],
                    'count_unread': 0,
                    'created_at': createdAt,
                    'creator_uin': userid,
                    'description': "",
                    'group_fullname': (user.full_name) ? user.full_name : user.phone || '',
                    'group_id': partner_id,
                    'last_active_messages': [],
                    'last_message': last_message,
                    'last_message_id': "",
                    'last_messages': [],
                    'last_sos_messages': [],
                    'locations': [],
                    'mode': 0,
                    'muted_uins': [],
                    'name': "",
                    'occupants_uins': [partner_id.toString(), userid.toString()],
                    'owner_uin': userid,
                    'partner_id': partner_id,
                    'pinned_messages': [],
                    'pinned_uins': [],
                    'received_list': [],
                    'removed_uins': [],
                    'secrets': [],
                    'seen_list': [],
                    'status_list': [],
                    'type': 3,
                    'unread_cnt': 0,
                    'updated_at': "",
                    'isDraft': true
                  }))

                  let newnameuser = checkNameUser(user) || ''
                  objGroup['fullnamegroup'] = (user.full_name) ? user.full_name : (newnameuser) ? newnameuser : user.phone || ''

                  this.props.updateGroupsDraft(objGroup, partner_id)
                  this.props.netaGroupsUpdate(objGroup.group_id, objGroup)
                  this.props.chooseGroupAction(objGroup)
                }
                setTimeout(() => {
                  funcCreateGroup()
                  this.resetState()
                  this.flagBtnChat = false
                }, 1000)
              })
            }
          }
        } catch (e) {
          console.log(e)
        }
      }
    }
  }

  addChangeNameGroup(e) {
    const value = e.target.value
    this.setState({ nameNewGroup: value })
  }

  onClickCreateGroup(type_popup) {
    if (!this.flagBtnGroup) {
      this.flagBtnGroup = true
      let type = (type_popup === 'channel' ? 4 : 2)
      let groupsNChatChecked = this.state.groupsNChatChecked
      let user = rxaget(this.state, 'user', {})
      // let nameNewGroup = this.state.nameNewGroup
      let nameNewGroup = this.groupName
      let emptyValue = ''
      if (this.groupName) {
        emptyValue = nameNewGroup.replace(/[\s]/g, '')
      }
      if (!emptyValue) {
        let arrNameTmp = []
        for (let uData of this.state.groupsNChatCheckedUser.slice(0, 3)) {
          let uName = rxaget(uData, 'full_name', '') || rxaget(uData, 'phone', '')
          if (uName) {
            let arrUname = uName.split(' ')
            if (arrUname && arrUname.constructor === Array && arrUname.length > 0) {
              arrNameTmp.push(arrUname[0].trim())
            }
          }
        }

        if (arrNameTmp.length > 0) {
          let strMyUserName = rxaget(this.props, 'netaauth.user.name', '') || rxaget(this.props, 'netaauth.user.phone', '')
          let arrMyUserName = strMyUserName.split(' ')
          let myUserName = (arrMyUserName && arrMyUserName.constructor === Array && arrMyUserName.length > 0) ? arrMyUserName[0] : ''

          let arrNameUniq = [...new Set(arrNameTmp)].slice(0, 3)
          if (myUserName) {
            nameNewGroup = myUserName + ', ' + arrNameUniq.join(', ')
          } else {
            nameNewGroup = arrNameUniq.join(', ')
          }
        }
      }

      // if (emptyValue.length > 0) {
      if (groupsNChatChecked.length === 0) {
        alert(translate('You have not selected a member'))
        this.flagBtnGroup = false
      } else {
        let params = {
          type: type,
          owner_uin: user.id,
          name: nameNewGroup,
          avatar_url: '',
          occupants_uins: groupsNChatChecked,
          sender_name: user.name
        }

        let tabTypeGroup = this.state.tabTypeGroup
        if (tabTypeGroup) {
          params['folders'] = [tabTypeGroup]
        }

        try {
          if (this.props.netaCreateGroupPopup && this.props.netaCreateGroupPopup.status) {
            let funcCreateGroup = this.props.netaCreateGroupPopup.callback

            if (groupsNChatChecked.length > 1) {
              rxio.createNewGroup(params, (data) => {
                if (data && data.group) {

                  let chooseFileImagesStatus = this.state.chooseFileImagesStatus
                  if (chooseFileImagesStatus) {
                    let groupImage = this.state.groupImage
                    this.uploadFileImages(groupImage, data.group)
                  } else {
                    this.props.chooseGroupAction(data.group)
                    // this.props.netaGroupsUpdate(Number(data.group.group_id), data.group)
                    let ogroup = data.group
                    ogroup.timestamp = (ogroup.last_message && ogroup.last_message.created_at) ? Number(ogroup.last_message.created_at) : (ogroup.updated_at) ? ogroup.updated_at : new Date().getTime() * 1000
                    ogroup.flagDraf = (ogroup.flagDraf) ? ogroup.flagDraf : '0' // 0 or 1
                    ogroup.flagPin = (ogroup && ogroup.pinned_uins && ogroup.pinned_uins.indexOf(this.userid.toString()) !== -1) ? '1' : '0'
                    ogroup.last_sort = '1' + ogroup.flagDraf + ogroup.flagPin + ogroup.timestamp

                    ogroup.received_list = []
                    ogroup.seen_list = []

                    const arrUins = rxaget(ogroup, 'occupants_uins', [])
                    if ((ogroup.type === 3 || ogroup.type === 5) && !ogroup.avatar_url && arrUins.length === 2) {
                      ogroup['partner_id'] = (arrUins[0].toString() === this.userid.toString()) ? arrUins[1] : arrUins[0]

                      let userInDB = chatDB.users.get({ uid: Number(ogroup['partner_id']) }).then(g => {
                        if (userInDB) {
                          ogroup['group_fullname'] = (userInDB && userInDB.name_display) ? userInDB.name_display : (userInDB.full_name) ? userInDB.full_name : (userInDB.phone) ? userInDB.phone : translate('Stranger')

                          ogroup['avatar_url'] = userInDB.profile_url || ''
                        } else {
                          ogroup['group_fullname'] = translate('Stranger')
                        }
                      })
                    } else {
                      ogroup['partner_id'] = 0
                      ogroup['group_fullname'] = nameNewGroup
                    }

                    ogroup.count_unread = 0

                    workerUnread.initUnread(ogroup.group_id, '-1')

                    chatDB.groups.add(ogroup, ogroup.group_id).then(g => {
                      this.props.changeGroupFunc()

                    }).catch(e => { })
                  }

                }
                setTimeout(() => {
                  this.groupName = ''
                  funcCreateGroup()
                  this.resetState()
                  this.flagBtnGroup = false
                }, 1000)
              })
            } else {
              alert(translate('The group must have at least three members'))
              this.flagBtnGroup = false
            }
          }
        } catch (e) {
          console.log(e)
          this.flagBtnGroup = false
        }
      }

      // } else {
      //   const mess = translate('The group name can not be blank')
      //   alert(mess)
      //   this.flagBtnGroup = false
      // }
    } else {
      setTimeout(() => {
        this.flagBtnGroup = false
      }, 2000)
    }
  }

  resetState() {
    this.setState({
      user: {},
      group: {},
      groupsNChat: [],
      groupsNChatOrigin: [],
      groupsNChatChecked: [],
      groupsNChatCheckedUser: [],
      flagPopup: false,
      flagCreateGroup: false,
      flagCreateGroupPopup: false,
      nameNewGroup: '',
      typePopup: '',
      groupImageURL: '',
      groupImage: '',
      chooseFileImagesStatus: false,

    }, () => {
      this.flagBtnGroup = false
      try {
        this.props.closeCreateGroupPopup()
      } catch (e) { }
    })
  }


  chooseFileImages(fileList) {
    let groupImageURL = URL.createObjectURL(fileList[0])
    this.setState({ groupImage: fileList, chooseFileImagesStatus: true, groupImageURL: groupImageURL })
  }

  uploadFileImages(fileList, groupObj) {
    try {
      if (fileList.length && fileList[0]) {
        var file = fileList[0]
        let parts = (file.name || '').split('.');
        let ext = parts[parts.length - 1] || '';
        if (['png', 'jpg'].indexOf(ext.toLowerCase()) >= 0) {
          let fileSize = file.size
          let extFilename = 'png'

          let _URL = window.URL || window.webkitURL
          let img = new Image();
          let objectUrl = _URL.createObjectURL(file)

          let dataParams = {
            content_type: 'image/' + extFilename,
            name: 'netalo_' + Math.floor(Date.now()),
            public: true,
            size: fileSize
          }
          let header = { 'TC-Token': this.token, 'Content-Type': 'application/json; charset=UTF-8', 'Accept-Encoding': 'gzip', 'Connection': 'keep-alive' }
          let requestOptions = {
            method: 'POST', headers: header, body: JSON.stringify(dataParams), redirect: 'follow'
          };

          fetch(global.rxu.config.create_blob, requestOptions).then(res => res.json()).then((json) => {
            if (json && json.blod_object && json.blod_object.form_data) {
              let dataUpload = new FormData()
              let arrKeys = ['Content-Type', 'key', 'policy', 'x-amz-algorithm', 'x-amz-credential', 'x-amz-date', 'x-amz-meta-netachat', 'x-amz-signature']
              for (let key of arrKeys) {
                if (json.blod_object.form_data[key]) {
                  dataUpload.append(key, json.blod_object.form_data[key])
                }
              }
              dataUpload.append('file', file, file.name)
              dataUpload.append('success_action_status', 201)

              fetch(json.blod_object.params, { method: 'POST', body: dataUpload }).then(resBlob => resBlob.text()).then(result => {
                if (result.indexOf('Key') !== -1) {
                  let patt = '<Key.*?>(.*?)<\\/Key>';
                  let strresult = result.match(patt);
                  if (strresult && strresult.constructor === Array && strresult.length > 1) {
                    let key = strresult[1]
                    if (key) {
                      let optComplete = {
                        method: 'PUT',
                        headers: header,
                        body: JSON.stringify({
                          content_type: json.content_type, id: json.id, name: json.name, size: json.size, uid: json.uid
                        })
                      };

                      fetch(global.rxu.config.get_blobs + '/' + json.id + '/complete.json', optComplete)
                        .then(response => {
                          if (response.status === 200) {
                            try {
                              img.onload = () => {
                                _URL.revokeObjectURL(objectUrl)
                                let msg = {
                                  group_id: Number(groupObj.group_id),
                                  avatar_url: key,
                                }
                                if (msg && msg.group_id) {
                                  if (rxio.connected) {
                                    rxio.socket.emit("update_group", msg, (data) => {
                                      if (data && data.result === 0) {
                                        this.props.chooseGroupAction(data.group)
                                        this.props.netaGroupsUpdate(Number(data.group.group_id), data.group)
                                      }
                                    })
                                  }
                                }
                              }
                              img.src = objectUrl
                            } catch (e) { }
                          }
                        }).catch(errorPut => console.log('error', errorPut));
                    }
                  }
                }
              })
            }
          }).catch(error => console.log('create_blob error', error))
        } else alert(translate('The image file format is not suitable. Please select the image file as .jpg or .png'))
      }
    } catch (error) { console.log('upload error', error) }
  }

  checkEleContactTitle(index) {
    let ele = this.state.groupsNChat[index]
    let elePre = this.state.groupsNChat[index - 1]
    let contactTitle = ''
    let eleContactTitle = rxChangeSlug(checkNameUser(ele, this.userid, this.props.netaauth)).slice(0, 1)
    let elePreContactTitle = rxChangeSlug(checkNameUser(elePre, this.userid, this.props.netaauth)).slice(0, 1)

    if (elePreContactTitle !== eleContactTitle) {
      contactTitle = eleContactTitle
    } else {
      contactTitle = ''
    }
    return contactTitle
  }

  checkPopupScreen() {
    let flagPopup = this.state.flagPopup
    let flagCreateGroup = this.state.flagCreateGroup
    let flagCreateGroupPopup = this.state.flagCreateGroupPopup
    if (flagPopup && (flagCreateGroup || flagCreateGroupPopup)) {
      return true
    }
    return false
  }

  handleScrollList(event) {
    if (event && event.scrollDirection === 'forward' && (this.state.heightListMember - 300) > 0 && event.scrollOffset > (this.state.heightListMember - 300)) {
      if (!this.blockScroll && this.state.searchNchatValue !== '') {
        this.blockScroll = true

        let pagingSearch = this.state.pagingSearch + 1

        this.onCallAPISearch(this.state.searchNchatValue, pagingSearch)
      }
    }
  }

  chooseTypeGroup(type) {
    this.setState({
      tabTypeGroup: type
    })
  }

  render() {
    let contactTitle = ''

    const Row = ({ index, style }) => {
      let userName = checkNameUser(this.state.groupsNChat[index])
      return <div style={style}>

        {this.state.groupsNChat[index].id !== this.userid && (<div key={index}>
          {this.checkEleContactTitle(index).length !== 0 && <div className='zcontact_title'>{this.checkEleContactTitle(index)}</div>}
          <div onClick={e => { this.createNewChat(this.state.groupsNChat[index]) }} className='group_contacts_item clearfix' >
            <div className='zgroup_avatar'>
              {this.state.groupsNChat[index].profile_url && (
                <img src={global.rxu.config.cdn_endpoint + this.state.groupsNChat[index].profile_url} alt=''
                  data-id={'userava' + this.state.groupsNChat[index].id} className='ava-useravatar images-static'
                  onError={e => { e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }}
                />
              )}
              {!this.state.groupsNChat[index].profile_url && <span className='ava-span' style={{ background: `${changeColorAva(rxaget(this.state.groupsNChat, index + '.group_id', ''))}` }} >
                {textAva(rxChangeSlug(checkNameUser(this.state.groupsNChat[index])))}
              </span>}
            </div>
            <div className='zgroup_maininfo-contact'>

              {(userName.length > 35) && <div className='newgroup_userinfo_place' username-tooltip-position='right' username-tooltip={userName}> {subString(userName, 35)}  </div>}
              {(userName.length <= 35) && <div className='newgroup_userinfo_place'> {userName} </div>}
              {(this.state.flagCreateGroupPopup || (['add_member', 'leave_group'].indexOf(this.state.typePopup) !== -1)) &&
                <div className='newgroup_checked'>
                  <label className='container100'>
                    <input className='checkmark1' type='checkbox' checked={this.state.groupsNChatChecked.indexOf(this.state.groupsNChat[index].id) !== -1} onChange={e => this.createNewChat(this.state.groupsNChat[index])} />
                    <span className='checkmark'></span>
                  </label>
                </div>
              }
            </div>
            <div className='newgroup_divider'></div>

          </div>
        </div>
        )}
      </div>
    };
    let itemCount = this.state.groupsNChat.length
    const getItemSize = index => {

      if (this.checkEleContactTitle(index).length !== 0) {
        return 90
      }
      return 60

    }
    const ContactList = () => (
      <VariableSizeList
        className="add_member_contact_list"
        height={370}
        itemCount={itemCount}
        itemSize={getItemSize}
        width={375}
      >
        {Row}
      </VariableSizeList>
    );


    return (
      <div>
        {(this.checkPopupScreen()) && <div className='zchat_popupscreen'>
          <div className='zchat_popupscreen_bg'></div>
          <div className='zchat_popupscreen_main'>
            {this.state.flagCreateGroup && <div className='zchat_popupcenter'>
              <div className='newgroup_rectangle_popup'>
                {/*---- Title ---- */}
                <div className='popup_choose_leader_title_area'>
                  <div className='popup_choose_leader_title'>
                    {(!this.state.flagCreateGroupPopup && this.state.typePopup !== 'add_member') && translate("New message")}
                    {(this.state.flagCreateGroupPopup && this.state.typePopup === 'create_group') && translate("Create a group")}
                    {(this.state.flagCreateGroupPopup && this.state.typePopup === 'create_channel') && translate("Create a channel")}
                  </div>
                  <div className='popup_choose_leader_btn_close'>
                    <img className='choose_leader_icon_close filter_img_class' alt='' src={changeColorSVG('./images/default/icons/icon-basic-up.svg')} onClick={e => this.onClickClosePopup()} />
                  </div>
                </div>

                {/*---- Nhập tên nhóm, thay đổi image ---- */}
                {this.state.flagCreateGroupPopup && <div className="newgroup_wrap">
                  <div className="newgroup_camera_icon_place" onClick={(e) => { this.refs.data_image_camera.click() }}>
                    <input type='file' id='data_image_camera' ref='data_image_camera' multiple={false} key={this.state.theInputFileKey + '_data_image_camera'}
                      style={{ display: 'none' }}
                      onChange={(e) => this.chooseFileImages(e.target.files)}
                      accept="image/jpg,image/png,video/mp4"
                    />

                    {this.state.groupImageURL.length === 0 && <div className="newgroup_icon_area icon_camera" >
                      <img className="newgroup_icon_search filter_img_class" src={changeColorSVG('./images/default/icons/camera.svg')} alt="" />
                    </div>}

                    {this.state.groupImageURL.length > 0 && <img className="newgroup_chooseAvatar" src={this.state.groupImageURL} alt="" />}
                  </div>

                  {/*<input placeholder={translate("Enter a group name")} maxLength="30" className="newgroup_place" onChange={e => this.addChangeNameGroup(e)} value={this.state.nameNewGroup || ""} />*/}
                  <InputGroupName onChange={(value) => { this.groupName = value }} />
                </div>}

                {/*---- Search danh sách user ---- */}
                <SearchUserName theme={rxaget(this.props, "themeBackgroudValue")} onChange={(value) => { this.onChangeSearchNChat(value) }} />

                {/* {this.state.flagCreateGroupPopup && <div className='header-typegroup-creategroup'>
                  <div className='header-creategroup-title'>
                    <span className='header-creategroup-title-txt'>Loại nhóm</span>
                  </div> */}
                {/* <div className={(this.state.tabTypeGroup === '2') ? 'header-creategroup-row active' : 'header-creategroup-row'} onClick={e => this.chooseTypeGroup('2')}>
                    <span className='header-creategroup-title-txt'>Nội bộ</span>
                  </div>
                  <div className={(this.state.tabTypeGroup === '3') ? 'header-creategroup-row active' : 'header-creategroup-row'} onClick={e => this.chooseTypeGroup('3')}>
                    <span className='header-creategroup-title-txt'>Khách hàng</span>
                  </div>
                </div>} */}

                {/*Hiển thị nút tạo group*/}
                {/*(!this.state.flagCreateGroupPopup && (['add_member', 'leave_group'].indexOf(this.state.typePopup) === -1)) &&
                  <div className='create_group_chat_area_popup'>
                    <img src={changeColorSVG('./images/default/icons/icon-basic-new-friend_group.svg')} alt='' className='avatar_create_group_chat_popup filter_img_class' />
                    <span className='new_group_chat_title_popup' onClick={e => this.onClickShowPopupCreateGroup()} >
                      {translate("Create a group chat")}
                    </span>
                  </div>
                */}

                {/*---- List danh sách user ---- */}
                <div className={this.state.flagCreateGroupPopup ? 'newgroup_popup_list' : 'newgroup_popup_list newGroupListBorder'}>
                  {
                    (this.state.groupsNChatCheckedUser.length > 0 && (['leave_group'].indexOf(this.state.typePopup) === -1)) &&
                    <div className='new_list_contacts_selected'>
                      {
                        this.state.groupsNChatCheckedUser.map((ele, index) => {
                          let checkedLength = this.state.groupsNChatCheckedUser.length - 1
                          let newUser = this.state.groupsNChatCheckedUser[checkedLength - index]
                          return <div key={newUser.id} className='item-row-selected-user'>
                            {subString(checkNameUser(newUser), 20)}
                            <img className='item-row-selected-close' src={changeColorSVG('./images/default/icons/icon-close.png')} alt='' onClick={e => { this.createNewChat(newUser) }} />
                          </div>
                        })
                      }
                    </div>
                  }
                  {/*<ContactList />*/}
                  <ListMemberRow
                    height={300}
                    width={375}
                    items={this.state.groupsNChat}
                    toggleItemActive={this.createNewChat}
                    groupsNChatChecked={this.state.groupsNChatChecked}
                    typePopup={this.state.typePopup}
                    flagCreateGroupPopup={this.state.flagCreateGroupPopup}
                    handleScrollList={this.handleScrollList}
                  />
                </div>
                {/*              <div className='newgroup_popup_list'>
                  <div className='add_member_contact_list'>
                    {this.state.groupsNChat.map((ele, index) => {
                      let eleContactTitle = rxChangeSlug(checkNameUser(ele, this.userid, this.props.netaauth)).slice(0, 1)
                      if (contactTitle !== eleContactTitle) {
                        ele.contactTitle = true
                        contactTitle = eleContactTitle
                      } else {
                        ele.contactTitle = false
                      }
                      return (
                        ele.id !== this.userid && (<div key={index}>
                          {ele.contactTitle && <div className='zcontact_title'>{eleContactTitle}</div>}
                          <div onClick={e => { this.createNewChat(ele) }} className='group_contacts_item clearfix' >
                            <div className='zgroup_avatar'>
                              {ele.profile_url && (
                                <img src={global.rxu.config.cdn_endpoint + ele.profile_url} alt=''
                                  data-id={'userava' + ele.id} className='ava-useravatar images-static'
                                  onError={e => { e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }}
                                />
                              )}
                              {!ele.profile_url && <span className='ava-span' style={{ background: `linear-gradient(120deg, ${stringToColour('FFF' + textAva(checkNameContact(ele)))}, #FFFFFF)` }} >
                                {textAva(rxChangeSlug(checkNameUser(ele)))}
                              </span>}
                            </div>
                            <div className='zgroup_maininfo-contact'>
                              <div className='newgroup_userinfo_place'> {subString(checkNameUser(ele), 20)} </div>
                              {(this.state.flagCreateGroupPopup || (['add_member', 'leave_group'].indexOf(this.state.typePopup) !== -1)) &&
                                <div className='newgroup_checked'>
                                  <label className='container100'>
                                    <input className='checkmark1' type='checkbox' checked={this.state.groupsNChatChecked.indexOf(ele.id) !== -1} onChange={e => this.createNewChat(ele)} />
                                    <span className='checkmark'></span>
                                  </label>
                                </div>
                              }
                            </div>
                            <div className='newgroup_divider'></div>
                          </div>
                        </div>
                        )
                      )
                    })}
                  </div>
                </div>
*/}
                {
                  this.state.flagCreateGroupPopup && (this.state.typePopup === 'create_group') &&
                  <div className='create-newgroup-row'>
                    <div className='create-newgroup-btn' onClick={e => this.onClickCreateGroup('group')}>
                      {translate("Create a group")}
                    </div>
                  </div>
                }
                {
                  this.state.flagCreateGroupPopup && (this.state.typePopup === 'create_channel') &&
                  <div className='create-newgroup-row'>
                    <div className='create-newgroup-btn' onClick={e => this.onClickCreateGroup('channel')}>
                      {translate("Create a channel")}
                    </div>
                  </div>
                }

              </div >
            </div >}
          </div>
        </div >}
      </div >
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  netaCreateGroupPopup: state.netaCreateGroupPopup,
  netaauth: state.netaauth,
  user: state.user,
  themeBackgroudValue: state.themeBackgroudValue,
})

const mapDispatchToProps = {
  closeCreateGroupPopup,
  changeStatusLoadMess,
  chooseGroupAction,
  netaGroupsUpdate,
  updateGroupsDraft,
  changeGroupFunc
}

const ComponentGroupListW = connect(
  mapStateToProps,
  mapDispatchToProps
)(RxGroupList)

export default ComponentGroupListW
